module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2017_07.e27f8874.jpg";